import config from '../../../config';
import {checkStatus, authFetch, fetchRetry} from '../../utils/http';

const PROJECT_API = `${config.projectApi}/api/v1/project`;

export default class LiveProjectService {
  createProjectWithDefaultIntervention(project) {
    return authFetch(`${PROJECT_API}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(project)
    })
      .then(checkStatus)
      .then(response => response.json());
  }

  updateProject(project, projectId) {
    return authFetch(`${PROJECT_API}/${projectId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(project)
    })
      .then(checkStatus)
      .then(response => response.json());
  }

  findOne(projectId) {
    return authFetch(`${PROJECT_API}/${projectId}`)
      .then(checkStatus)
      .then(response => response.json());
  }

  closeProject(projectId) {
    return authFetch(`${PROJECT_API}/close/${projectId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(checkStatus)
      .then(response => response.json());
  }

  getInternalNotes(projectId) {
    return authFetch(`${PROJECT_API}/${projectId}/internal-notes`)
      .then(checkStatus)
      .then(response => response.json());
  }

  createInternalNote(projectId, contentNote) {
    return authFetch(`${PROJECT_API}/${projectId}/internal-notes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(contentNote)
    })
      .then(checkStatus);
  }

  getProjectUserPermissions(projectId, organisationId) {
    return authFetch(`${PROJECT_API}/${projectId}/user-permissions?organisationId=${organisationId}`)
      .then(checkStatus)
      .then(response => response.json());
  }

  upgradeProject(projectId) {
    return authFetch(`${PROJECT_API}/upgrade/${projectId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(checkStatus)
      .then(response => response.json());
  }

  cancelPendingIntervention(interventionId) {
    return authFetch(`${config.projectApi}/api/v1/intervention/${interventionId}`, {
      method: 'DELETE'
    })
      .then(checkStatus);
  }

  isProjectReady(interventionId) {
    return fetchRetry(() => authFetch(`${config.documentApi}/api/v1/dossiers/states?interventionId=${interventionId}`), [403, 404]);
  }

  isProjectCreated(projectId) {
    return fetchRetry(() => authFetch(`${config.documentTypeApi}/api/v1/project-obligations/projects/${projectId}/document-types`), [403, 404], false);
  }

  updateProjectRequiredDocumentsAlreadyDone(projectId) {
    return authFetch(`${config.documentApi}/api/v1/project-obligations/projects/${projectId}/document-types`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(checkStatus);
  }

  isPostCodeValid(country, postCode) {
    return authFetch(`${PROJECT_API}/validate-postcode`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({country, postCode})
    })
      .then(checkStatus)
      .then(res => res.json());
  }
}
